/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPageSignOff = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20 7.586V10h-2V9h-5V4H6v16h4v2H4V2h10.414zM15 7h1.586L15 5.414z" />
        <path d="M17.293 12.293a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414L16.414 22H12v-4.414zM14 18.414V20h1.586l4-4L18 14.414zm-3.292-9.413c.253-.009.555.054.82.264.255.2.382.462.446.675.115.39.08.835.012 1.242l-.007.048c.08-.018.171-.04.275-.066.447-.114 1.152-.315 1.837-.317.75-.003 1.593.233 2.209 1.053l-1.6 1.2c-.134-.18-.292-.254-.603-.253-.378 0-.798.115-1.35.256-.247.062-.54.134-.821.168-.265.03-.66.047-1.046-.123-.458-.2-.742-.586-.86-1.036a2.073 2.073 0 0 1-.052-.282 18.286 18.286 0 0 0-1.034 1.21 20.431 20.431 0 0 0-.131.166l-.006.009-.002.002-1.59-1.213.001-.001.002-.004.009-.01.032-.042a19.012 19.012 0 0 1 .522-.648c.33-.394.78-.908 1.227-1.334a5.68 5.68 0 0 1 .711-.589c.205-.14.569-.36.999-.375z" />
      </g>
    </g>
  </Icon>
);
export { SvgPageSignOff as PageSignOff };
